import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { SITE } from "@/constants/site";

export default function Datenschutz() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <main className="min-h-screen bg-cream py-24 md:py-32" data-testid="datenschutz-page">
            <div className="max-w-3xl mx-auto px-6">
                <Link
                    to="/"
                    className="inline-flex items-center gap-2 text-gold-deep hover:text-gold transition-colors text-xs tracking-[0.25em] uppercase mb-12"
                    data-testid="datenschutz-back"
                >
                    <ArrowLeft className="w-4 h-4" /> Startseite
                </Link>

                <h1 className="font-display text-ink text-4xl sm:text-5xl tracking-tight mb-4">Datenschutzerklärung</h1>
                <div className="h-[1px] bg-gold/40 mb-12" />

                <div className="space-y-10 font-sans text-ink/80 leading-relaxed">
                    <section>
                        <h2 className="eyebrow mb-4">1. Verantwortliche Stelle</h2>
                        <p className="text-ink font-medium">{SITE.name}</p>
                        <p>Inhaberin: Tijana Alic</p>
                        <p>{SITE.address.street}, {SITE.address.city}, {SITE.address.country}</p>
                        <p>Telefon: {SITE.phone}</p>
                        <p>E-Mail: {SITE.email}</p>
                    </section>

                    <section>
                        <h2 className="eyebrow mb-4">2. Allgemeine Hinweise</h2>
                        <p>
                            Der Schutz Ihrer persönlichen Daten ist mir ein wichtiges Anliegen. Personenbezogene
                            Daten werden auf dieser Website nur im technisch notwendigen Umfang und im Rahmen der
                            gesetzlichen Bestimmungen (DSGVO, TTDSG) erhoben. Diese Erklärung informiert Sie darüber,
                            welche Daten beim Besuch dieser Website verarbeitet werden.
                        </p>
                    </section>

                    <section>
                        <h2 className="eyebrow mb-4">3. Kontaktformular und E-Mail-Kontakt</h2>
                        <p>
                            Wenn Sie mir über das Kontaktformular oder per E-Mail eine Anfrage senden, werden Ihre
                            Angaben (Name, E-Mail-Adresse, ggf. Telefonnummer und Nachrichtentext) zwecks
                            Bearbeitung der Anfrage und für den Fall von Anschlussfragen verarbeitet.
                            Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO (vorvertragliche Maßnahmen) bzw.
                            Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an der Beantwortung von Anfragen).
                            Die Daten werden nicht an Dritte weitergegeben und nach abschließender Bearbeitung
                            gelöscht, sofern keine gesetzlichen Aufbewahrungspflichten bestehen.
                        </p>
                    </section>

                    <section>
                        <h2 className="eyebrow mb-4">4. WhatsApp</h2>
                        <p>
                            Diese Website verlinkt auf WhatsApp (WhatsApp Ireland Limited). Wenn Sie den Link
                            anklicken, wird Ihre Rufnummer an WhatsApp übermittelt und es gelten die
                            Datenschutzbestimmungen von WhatsApp. Es findet keine Datenübertragung statt, solange
                            Sie den Link nicht aktiv anklicken.
                        </p>
                    </section>

                    <section>
                        <h2 className="eyebrow mb-4">5. Google Maps</h2>
                        <p>
                            Zur Darstellung des Salonstandorts wird Google Maps (Google Ireland Limited, Gordon
                            House, Barrow Street, Dublin 4, Irland) eingebunden. Beim Aufruf der Karte werden Daten
                            (insbesondere Ihre IP-Adresse) an Google übertragen; dabei kann es auch zu einer
                            Übertragung in die USA kommen. Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO
                            (berechtigtes Interesse an einer ansprechenden Darstellung und leichten Auffindbarkeit
                            des Standorts). Details finden Sie in der Datenschutzerklärung von Google.
                        </p>
                    </section>

                    <section>
                        <h2 className="eyebrow mb-4">6. Lokale Speicherung (localStorage)</h2>
                        <p>
                            Diese Website speichert Ihre gewählte Sprache im lokalen Speicher Ihres Browsers
                            (localStorage). Dabei handelt es sich um eine technisch notwendige Speicherung gemäß
                            § 25 Abs. 2 TTDSG; es werden keine Tracking- oder Marketing-Cookies gesetzt.
                        </p>
                    </section>

                    <section>
                        <h2 className="eyebrow mb-4">7. Server-Logdateien</h2>
                        <p>
                            Der Hosting-Anbieter erhebt und speichert automatisch Informationen in sogenannten
                            Server-Logdateien (z. B. IP-Adresse, Datum und Uhrzeit des Zugriffs, Browsertyp), die
                            Ihr Browser automatisch übermittelt. Diese Daten werden nicht mit anderen
                            Datenquellen zusammengeführt. Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO.
                        </p>
                    </section>

                    <section>
                        <h2 className="eyebrow mb-4">8. Ihre Rechte</h2>
                        <p>
                            Sie haben jederzeit das Recht auf unentgeltliche Auskunft über Ihre gespeicherten
                            personenbezogenen Daten, deren Herkunft und Empfänger und den Zweck der
                            Datenverarbeitung sowie ein Recht auf Berichtigung oder Löschung dieser Daten
                            (Art. 15–17 DSGVO). Außerdem haben Sie das Recht auf Datenübertragbarkeit (Art. 20
                            DSGVO) und können einer Verarbeitung widersprechen (Art. 21 DSGVO). Hierzu sowie zu
                            weiteren Fragen zum Thema Datenschutz können Sie sich jederzeit an die oben genannte
                            verantwortliche Stelle wenden.
                        </p>
                    </section>

                    <section>
                        <h2 className="eyebrow mb-4">9. Beschwerderecht bei der Aufsichtsbehörde</h2>
                        <p>
                            Im Falle datenschutzrechtlicher Verstöße steht Ihnen ein Beschwerderecht bei der
                            zuständigen Aufsichtsbehörde zu. Zuständig ist der Landesbeauftragte für den
                            Datenschutz und die Informationsfreiheit Baden-Württemberg (LfDI), Lautenschlagerstraße
                            20, 70173 Stuttgart.
                        </p>
                    </section>

                    <section>
                        <h2 className="eyebrow mb-4">10. SSL- bzw. TLS-Verschlüsselung</h2>
                        <p>
                            Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher
                            Inhalte eine SSL- bzw. TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie
                            daran, dass die Adresszeile des Browsers mit „https://" beginnt.
                        </p>
                    </section>

                    <p className="text-xs text-ink/50 pt-6 border-t border-gold/25">
                        Stand: Oktober 2026
                    </p>
                </div>
            </div>
        </main>
    );
}
